import { Button, withStyles } from '@material-ui/core';

const PrimaryButton = withStyles({
  root: {
    color: 'white',
    fontSize: '1.3rem',
    secondary: {
      '&:hover': {
        background: '#af131a',
      },
    },
    primary: {
      '&:hover': {
        background: '#057b98',
      },
    },
  },
})(Button);

export default PrimaryButton;
